import React from 'react'
import SvgIcon, { SvgIconProps } from 'LuxKit/SvgIcon'

function LineStoreIcon(props: SvgIconProps) {
  return <SvgIcon {...props} fill="none" viewBox="0 0 24 24">
    <path fill="currentColor" d="M22 7.82a1.2553 1.2553 0 0 0 0-.19l-2-5A1 1 0 0 0 19 2H5a1.0001 1.0001 0 0 0-.93.63l-2 5a1.25 1.25 0 0 0 0 .19A.58.58 0 0 0 2 8a4 4 0 0 0 2 3.4V21a1 1 0 0 0 1 1h14a.9997.9997 0 0 0 1-1v-9.56A4.0007 4.0007 0 0 0 22 8a.578.578 0 0 0 0-.18ZM13 20h-2v-4h2v4Zm5 0h-3v-5a1.0001 1.0001 0 0 0-1-1h-4a1.0002 1.0002 0 0 0-1 1v5H6v-8a3.9996 3.9996 0 0 0 3-1.38 4.0008 4.0008 0 0 0 3 1.3543 4.0003 4.0003 0 0 0 3-1.3543A3.9995 3.9995 0 0 0 18 12v8Zm0-10a2 2 0 0 1-2-2 1.0001 1.0001 0 0 0-1.7071-.707A1.0001 1.0001 0 0 0 14 8a2 2 0 1 1-4 0 1 1 0 0 0-2 0 2.0014 2.0014 0 1 1-4 .15L5.68 4h12.64L20 8.15A1.9997 1.9997 0 0 1 18 10Z"/>
  </SvgIcon>
}

export default LineStoreIcon
